export default "__VITE_ASSET__BRcD$Y8k__"